import { StorageKey } from "_constants";
import { ModalCrowdFunding } from "components/user/crowdfunding/ModalCrowdFunding";
import { useState } from "react";

export function useModalCrowdFunding (initialValue: string | null) {

  const [ show, setShow ] = useState<boolean>(initialValue === null);

  const handleClose = () => {
    setShow(false);
    localStorage.setItem(StorageKey.SEEN_CROWDFUND, '1');
  }

  const modalElement = () => {
    return <ModalCrowdFunding show={show} handleClose={handleClose} />
  }

  return {
    modalElement
  }
  
}